module.exports = __webpack_public_path__ + "img/92ne.ebfdf6a1.svg";